export default __webpack_public_path__ + "static/media/habilitar-permiso-camara-iphone-1.7564cbbf.svg";